import { useMutation, MutationHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { createCategory, createCategoryVariables } from './__queries__';

const CREATE_CATEGORY = gql`
  mutation createCategory(
    $name: String!
    $description: String
    $order: Int
    $imageId: ID
    $itemsIds: [ID!]!
    $companyId: ID!
    $color: String
  ) {
    node: createCategory(
      name: $name
      description: $description
      order: $order
      imageId: $imageId
      itemsIds: $itemsIds
      companyId: $companyId
      color: $color
    ) {
      id
      name
    }
  }
`;

export const useCreateCategory = (
  mutationOptions?: MutationHookOptions<createCategory, createCategoryVariables>,
) => {
  return useMutation<createCategory, createCategoryVariables>(CREATE_CATEGORY, mutationOptions);
};
